import React, { Component } from 'react';
import { withStyles, fade } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { AppBar, Toolbar, Hidden, Grid, IconButton, Tab, Tabs, Badge, Menu, MenuItem, ListItemIcon, ListItemText, Divider, Drawer } from '@material-ui/core';
import classNames from "classnames";
import i18n from '../translations/i18n'
import { getContacts, getAppCfg, setNotificationListener, getSupportOrder } from '../utils/common';
import { withTranslation } from 'react-i18next'
import crmServices from '../wsclient/crmservices'
import Typo from './CustomTypo';
import Button from './ButtonCustom';
import { MenuIcon, NotificationsIcon, MailIcon, ProfileIcon, LogoutIcon } from './icons';
import { expandProfileConfig,menuWithoutOfferConfig, menuWithoutOrderConfig, menuFull } from '../../portal.menu.config'
import t from '../utils/translateUtil';
import { logOut, getLanguage, saveDataIntoAsyncStore } from '../utils/common'
import { portal_config, custom_assets, domainName } from '../../portal.config'
import { isRetina } from '../utils/util';
import { portalCfg,navigate, paths } from '../../portal.router.config'
import { dataUtil, usage_type } from '../wsclient/crmservices/dataUtil';
import { getOrderCache, order_key } from '../utils/order_cache';
import MenuItemsController from '../pages/orders/MenuItemsController';
import CustomTypo from './CustomTypo';
import crmservices from '../wsclient/crmservices';
var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
const drawerWidth = 180;
const headerStyles = theme => ({
    appBar: {
        width: '100%',
        boxShadow: 'none',
        backgroundColor: theme.palette.background.header,
        // [theme.breakpoints.down('sm')]: {
        //     width: '100%',
        //     marginLeft: 0,
        //     paddingLeft: theme.spacing(2),
        // },
    },
    toolBar: {
        height: 80,
        width: '90%',
        marginLeft: '5%',
        marginRight: '5%',
        [theme.breakpoints.up('xl')]: {
            width: '80%',
            marginLeft: '10%',
            marginRight: '10%',
        },
    },
    drawerPaper: {
        backgroundColor: theme.palette.background.drawer,
    },
    badgeColorPrimary: {
        ...theme.palette.button.light,
    },
    tabsRoot: {
        color: theme.palette.text.onPrimary,
        '&:focus': {
            opacity: 1,
        }
    },
    tabRoot: {
        minWidth: 100,
        color: theme.palette.text.tab,
    },
    tabSelected: {
        color: theme.palette.text.tabSelected,
        alignItems: 'center',
    },
    grow: {
        flexGrow: 1,
    },
    leftAction: {
        paddingRight: theme.spacing(3)
    },
    logo_img_contaner_square: {
        // backgroundColor:'#fff',
        width: 200,
        height: 100,
        // borderRadius:100,
        position: 'absolute',
        top: 0,
        left: `calc(48% - ${16}px)`,
        zIndex: 1105,
        [theme.breakpoints.down('xs')]: {
            left: `calc(25% - ${16}px)`,
        },
    },
    logo_img_contaner: {
        backgroundColor: '#fff',
        width: 100,
        height: 100,
        borderRadius: 100,
        position: 'absolute',
        top: 30,
        left: `calc(47% - ${16}px)`,
        zIndex: 1105,
        [theme.breakpoints.down('xs')]: {
            left: `calc(25% - ${16}px)`,
        },
    },
    logo_img: {
        width: 100,
        height: 100,
        borderRadius: 100,
        objectFit: 'contain'
    },
    logo_img_square: {
        width: 200,
        height: 100,
        //borderRadius: 100,
        objectFit: 'contain'
    },
    logo_img_small_contaner_square: {
        marginTop:theme.spacing(4),
        marginLeft:theme.spacing(17),
        //backgroundColor:'#fff',
        width:100,
        height:50,
      //  borderRadius:50,
    },
    logo_img_small_contaner: {
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(17),
        backgroundColor: '#fff',
        width: 50,
        height: 50,
        borderRadius: 50,
    },
    logo_img_small: {
        width: 50,
        height: 50,
        borderRadius: 50,
        objectFit: 'contain'
    },
    logo_img_small_square: {
        width: 100,
        height: 50,
        // borderRadius: 50,
        objectFit: 'contain'
    },
    menuIcon: {
        marginRight: theme.spacing(2),
        marginBottom: '0px!important'
    },
    button: {
        marginLeft: theme.spacing(4)
    }
});

class Header extends Component {

    constructor(props) {
        super(props);
        var app_config = getAppCfg();
        var menuConfig = menuFull
        //console.log('Header menuConfig=',menuConfig)
        if(menuConfig[1]&&menuConfig[1].id==='map'){
        menuConfig[1].showMenu = portal_config[domainName].showMapHeader
        }
        if (menuConfig[2]&&menuConfig[2].id==='offers'){
        menuConfig[2].showMenu = app_config && app_config.features && app_config.features.rewards;
        }
        if(menuConfig[3]&&menuConfig[3].id==='orders'){
        menuConfig[3].showMenu = getSupportOrder()
        }
        if(menuConfig[4]&&menuConfig[4].id==='subcriptions'){
            menuConfig[4].showMenu = app_config && app_config.features && app_config.features.subscription;
        }
        if(menuConfig[5]&&menuConfig[5].id==='online_shop'){
        menuConfig[5].showMenu = portal_config[domainName].showOnlineShope
        }
        if(menuConfig[6]&&menuConfig[6].id==='invoice'){
        menuConfig[6].showMenu = portal_config[domainName].showInvoicePage
        }
        if(menuConfig[7]&&menuConfig[7].id==='wallet'){
            menuConfig[7].showMenu = portal_config[domainName].showInvoicePage
        }
        const showServiceRequests = app_config && app_config.features && app_config.features.crm_details && app_config.features.crm_details.service_requets ? app_config.features.crm_details.service_requets : false;
        if(menuConfig[8]&&menuConfig[8].id==='service_requests' && showServiceRequests){
        menuConfig[8].showMenu = domainName == 'airlink' 
        }
        var newMenu = []
        var index = 0;
        menuConfig.forEach((menu,i)=>{
            if(menu.showMenu){
                var item = menu
                item.index = index
                index = index+1;
                newMenu.push(item)
            }
            
        })

        //console.log('Header newMenu=',newMenu)
        //for Order My Profile
        if (!getSupportOrder()){
            let branches = domainName;
            if (!expandProfileConfig[branches]){
                branches = 'release'
            }
            expandProfileConfig[branches].forEach((item,index)=>{
                if(item.id==='order_history'){
                    expandProfileConfig[branches].splice(index,1)// delete if Order disable
                }
            })
        }

        this.state = {
            currentPageConfig: {},
            menuConfig: newMenu,
            showProfileMenu: false,
            menu: false,
            currentLanguge: getLanguage("LANGUAGE"),
            showMenuItem: false,
            numItemCart: 0,
            openFromHeader: true,
        }
        this.logout = this.logout.bind(this);
        this.goToHome = this.goToHome.bind(this);
        this.goBack = this.goBack.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleProfileMenuOpen = this.handleProfileMenuOpen.bind(this)
        this.onClickItem = this.onClickItem.bind(this)
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.openMenuItem = this.openMenuItem.bind(this)
        this.refreshTotalCartItem = this.refreshTotalCartItem.bind(this);
    }
    componentDidUpdate() {
        //console.log('componentDidUpdate  ')
    }
    componentWillMount() {
        this.refreshTotalCartItem();
        setNotificationListener(this.refreshTotalCartItem);
    }

    componentWillUnmount() {
        setNotificationListener(undefined);
    }
    refreshTotalCartItem(isAdd) {
        console.log(' getOrderCache(order_key.order_status, true)===', getOrderCache(order_key.order_status, true))
        if (getOrderCache(order_key.order_status, true) === 'DONE') {
            this.setState({ numItemCart: 0, showMenuItem: false })
        }
        else {
            this.setState({ numItemCart: dataUtil.getTotalCartQuantity(getOrderCache(order_key.cart) ? getOrderCache(order_key.cart) : []) })
        }
        // if(isAdd){
        //     this.setState({showMenuItem:false});
        // }
    }
    logout() {
        this.props.history.push('/')
    }
    goToHome() {
        this.props.history.push('/')
    }
    goBack() {
        this.props.history.goBack();
    }
    getPageActive() {
        var path = window.location.pathname;
        console.log('path====', path)

        
          
        if (portalCfg.basename){
            path = path.replace(portalCfg.basename,'')
        }

        if (path === '/' | path === '')
            path = '/home';

        var menuConfig = this.state.menuConfig;

        var currentPage = menuConfig.filter(page => page.route === path);
        if (currentPage && currentPage.length > 0) {
            return currentPage[0];
        }else{
            if(path.includes('/process_order')||path.includes('/process_topup')||path.includes('/process_addcard')){
                return {}
            }
            else return null;
        }
    }
    handleChange = (event, newValue) => {
        var menuConfig = this.state.menuConfig;
        var pageActive = menuConfig[newValue];
        navigate(pageActive.route);
    };
    onClickMenuDrawer(menu) {
        navigate(menu.route);
        this.toggleDrawer()
    }
    handleProfileMenuOpen() {
        this.setState({ showProfileMenu: !this.state.showProfileMenu });
    }
    createImage(classes, small) {
        var logo_img_contaner_square = classes.logo_img_contaner_square
        var logo_img_contaner = classes.logo_img_contaner
        var logo_img_square = classes.logo_img_square
        var logo_img = classes.logo_img
        if(small){
            logo_img_contaner_square = classes.logo_img_small_contaner_square
            logo_img_contaner = classes.logo_img_small_contaner
            logo_img_square = classes.logo_img_small_square
            logo_img = classes.logo_img_small
        }
        if (portal_config[domainName].localLogo) {
            return (<div className={portal_config[domainName].logoStyle=='square' ? logo_img_contaner_square : logo_img_contaner}> 
                    <img src={isRetina(path + "/images/logo.png", path + "/images/logo@2x.png")} className={portal_config[domainName].logoStyle=='square' ? logo_img_square : logo_img} />
                    </div>)
        } else {
            var app_config = getAppCfg();
            var srcset = ""
            var logoUrl = ""
            if (app_config && app_config.creatives && app_config.creatives.length > 0) {
                var media = app_config.creatives[0].media;
                if (media && media.length > 0) {
                    var srcset = ""
                    media.forEach((element, index) => {
                        srcset = srcset + element.url + " " + (index + 1) + "x,";
                    });
                    if (srcset)
                        srcset = srcset.substr(0, srcset.length - 1);
                }
                let business_logo = dataUtil.getImageByUsageTypePortal(app_config.creatives, usage_type.APP_LOGO, true);
				if(business_logo){
					logoUrl = business_logo ? business_logo : null;
				}else{
					//var path = custom_assets[domainName] && custom_assets[domainName].customImage.logo  ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
					logoUrl = path+ "/images/logo.png";
				}
            }
            if (srcset) {
                return (<div className={portal_config[domainName].logoStyle=='square' ? logo_img_contaner_square : logo_img_contaner}> 
                            <img src={logoUrl.url ? logoUrl.url : logoUrl} className={portal_config[domainName].logoStyle=='square' ? logo_img_square : logo_img} />
                            </div>)
            } else if (logoUrl) {
                return (<div className={portal_config[domainName].logoStyle=='square' ? logo_img_contaner_square : logo_img_contaner}> 
                        <img src={logoUrl.url ? logoUrl.url : logoUrl} className={portal_config[domainName].logoStyle=='square' ? logo_img_square : logo_img} />
                        </div>)
            } else {
            return (<div className={logo_img_contaner_square}>
                        <Grid xs ={12} item container justify='center' alignItems='center'>
                            <CustomTypo mg_top_xl variant={small?'h6':'h3'} className={logo_img_square} center color='onPrimary'>{portal_config[domainName].app_name}</CustomTypo>
                        </Grid>
                    </div>)
            }
        }
    }
    getIcon(menu, classes, isActive) {
        var MyIcon = isActive ? menu.iconActive : menu.icon;
        return <MyIcon className={classes} />
    }
    onClickItem(menu) {
        if(menu.id == 'service_requests')
            this.props.history.push(paths.service_requests);
        else {
            this.setState({ showProfileMenu: false })
            this.props.onOpenDrawerOther(menu.id)
        }
    }
    toggleDrawer() {
        this.setState({ menu: !this.state.menu })
    }
    async onLogout() {
        logOut();
    }

    async onChangeLanguage() {
        var currentLanguage = this.state.currentLanguge;
        var language = "";
        if (currentLanguage == 'ENG') {
            language = "GR";
        } else {
            language = "ENG";
        }
        this.setState({ currentLanguge: language })
        saveDataIntoAsyncStore('LANGUAGE', language);
        i18n.changeLanguage(language);
        crmservices.contacts.updateContactLanguage(language);
    }
    openMenuItem() {
        this.setState({ showMenuItem: !this.state.showMenuItem })
    }
    render() {
        const { classes, t } = this.props;
        const profileName = crmServices.getSession()
        var currentPageConfig = this.getPageActive();
        var app_config = getAppCfg()
        //console.log("XXXXXXXXXXXXXXXXXXXXXXXXX numItemCart:", this.state.numItemCart);
        if (currentPageConfig) {
            var Icon = currentPageConfig.iconHeader;
            var menuConfig = this.state.menuConfig;
            console.log("AAAAA menuConfig====", menuConfig);
            return (
                <div>
                    <AppBar position="fixed" className={classes.appBar}>
                        <Hidden lgUp implementation="css">
                            <Toolbar className={classes.toolBar}>
                                <IconButton
                                    color="primary"
                                    aria-label="open drawer"
                                    edge="start"
                                    onClick={this.toggleDrawer}
                                    className={classes.menuButton}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <div className={classes.grow} />
                                <div className={classes.leftAction}>
                                    {domainName !== 'airlink' && <IconButton onClick={() => this.onChangeLanguage()}>
                                        <Typo color='onPrimary'>{this.state.currentLanguge}</Typo>
                                    </IconButton>}
                                    <IconButton aria-label="show 17 new notifications" color="inherit" onClick={() => this.props.onOpenDrawerOther('notifications')}>
                                        <Badge badgeContent={this.props.num_notification} color="primary" classes={{ colorPrimary: classes.badgeColorPrimary }}>
                                            <NotificationsIcon />
                                        </Badge>
                                    </IconButton>
                                    {app_config && app_config.features && app_config.features.ordering&&<IconButton onClick={() => this.openMenuItem()}>
                                        <Badge badgeContent={this.state.numItemCart} color="primary" classes={{ colorPrimary: classes.badgeColorPrimary }}>
                                            <MailIcon />
                                        </Badge>
                                    </IconButton>}
                                    <IconButton onClick={this.handleProfileMenuOpen}
                                        edge="end"
                                        aria-controls="appbar-profile-menu"
                                        aria-haspopup="true"
                                        color="inherit">
                                        <ProfileIcon />
                                    </IconButton>
                                    <ProfileMenu
                                        showProfileMenu={this.state.showProfileMenu}
                                        handleClose={this.handleProfileMenuOpen}
                                        classes={classes} onClickItem={this.onClickItem}
                                        contactName={profileName && profileName.full_name ? profileName.full_name : ""}
                                        onLogout={this.onLogout} />
                                </div>
                                {/* <div className={classes.logo_img_small_contaner}>
                                    {this.createImage(classes.logo_img_small)}
                                </div> */}
                            </Toolbar>
                        </Hidden>
                        <Hidden mdDown implementation="css">
                            <Toolbar className={classes.toolBar}>
                                <Tabs selectionFollowsFocus={true} TabIndicatorProps={{ style: { height: "0", display: 'none' } }}
                                    classes={{ root: classes.tabsRoot }}
                                    value={currentPageConfig.index}
                                    onChange={this.handleChange}>
                                    {menuConfig.map((menu, index) => menu.showMenu ?
                                        <Tab key={index} icon={this.getIcon(menu, classes.menuIcon, currentPageConfig.index == index)} label={t(menu.title)} classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                                        : null)}
                                </Tabs>
                                <div className={classes.grow} />
                                <div className={classes.leftAction}>
                                    {domainName !== 'airlink' && <IconButton onClick={() => this.onChangeLanguage()}>
                                        <Typo color='onPrimary'>{this.state.currentLanguge}</Typo>
                                    </IconButton>}
                                    <IconButton aria-label="show 17 new notifications" color="inherit" onClick={() => this.props.onOpenDrawerOther('notifications')}>
                                        <Badge badgeContent={this.props.num_notification} color="primary" classes={{ colorPrimary: classes.badgeColorPrimary }}>
                                            <NotificationsIcon />
                                        </Badge>
                                    </IconButton>
                                    {app_config && app_config.features && app_config.features.ordering&&<IconButton onClick={() => this.openMenuItem()}>
                                        <Badge badgeContent={this.state.numItemCart} color="primary" classes={{ colorPrimary: classes.badgeColorPrimary }}>
                                            <MailIcon />
                                        </Badge>
                                    </IconButton>}
                                    <IconButton onClick={this.handleProfileMenuOpen}
                                        edge="end"
                                        aria-controls="appbar-profile-menu"
                                        aria-haspopup="true"
                                        color="inherit">
                                        <ProfileIcon />
                                    </IconButton>
                                    <ProfileMenu
                                        showProfileMenu={this.state.showProfileMenu}
                                        handleClose={this.handleProfileMenuOpen}
                                        classes={classes} onClickItem={this.onClickItem}
                                        contactName={profileName && profileName.full_name ? profileName.full_name : ""}
                                        onLogout={this.onLogout} />
                                </div>
                                    {this.createImage(classes)}
                            </Toolbar>
                        </Hidden>
                    </AppBar>
                    <Drawer anchor={"top"} open={this.state.menu} onClose={this.toggleDrawer} classes={{
                        paper: classes.drawerPaper,
                    }}>
                        {this.createImage(classes, true)}
                        {menuConfig.map((menu, index) => menu.showMenu ?
                            <MenuItem key={index} onClick={() => this.onClickMenuDrawer(menu)}>
                                <ListItemIcon>
                                    {this.getIcon(menu, classes.menuIcon, currentPageConfig.index == index)}
                                </ListItemIcon>
                                <Typo color={currentPageConfig.index == index ? "tertiary" : "label"}>{t(menu.title)}</Typo>
                            </MenuItem>

                            : null)}
                    </Drawer>
                    {this.state.showMenuItem && this.state.numItemCart > 0 && <MenuItemsController open={this.state.showMenuItem} onClose={this.openMenuItem} openFromHeader />}
                </div>
            );
        }
        else
            return null
    }
}

function ProfileMenu(props) {
    const { classes, onClickItem, contactName, onLogout } = props
    const StyledMenu = withStyles({
        paper: {
            border: '1px solid #d3d4d5',
            borderRadius: 12,
            top: '90px!important',
            width: 300,
            right: '10%'
        },
    })((props) => (
        <Menu
            id="appbar-profile-menu"
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            {...props}
        />
    ));
    const StyledMenuItem = withStyles((theme) => ({
        root: {

        },
    }))(MenuItem);
    const app_config = getAppCfg();
    const isRewards = app_config && app_config.features && app_config.features.rewards ? app_config.features.rewards : false;
    const isOrder = app_config && app_config.features && app_config.features.ordering ? app_config.features.ordering : false;
    const showTopup = app_config&& app_config.features && app_config.features.finance_details && app_config.features.finance_details.wallet_top_up ? app_config.features.finance_details.wallet_top_up : false ;
    const showServiceRequests = app_config && app_config.features && app_config.features.crm_details && app_config.features.crm_details.service_requets ? app_config.features.crm_details.service_requets : false;
    const showMobilePass = app_config && app_config.features && app_config.features.mobile_passes ? app_config.features.mobile_passes : false;
    let branches = domainName;
    const isRedeemPass = app_config && app_config.features && app_config.features.finance_details && app_config.features.finance_details.redeem_pass ? app_config.features.finance_details.redeem_pass : false;
    console.log("isRedeemPass==", isRedeemPass);
    if (!expandProfileConfig[branches]) {
        branches = 'release'
    }
    return (
        <StyledMenu
            id="customized-menu"
            anchorEl={props.showProfileMenu}
            keepMounted
            open={props.showProfileMenu}
            onClose={props.handleClose}
        >
            <StyledMenuItem>
                <Grid>
                    <Typo variant="subtitle2">{contactName}</Typo>
                    {/* <Typo variant="description">iron19932009@hotmail.com</Typo> */}
                </Grid>
            </StyledMenuItem>
            {/* <StyledMenuItem onClick={() => onClickItem(expandProfileConfig[0])}> */}
            <Button color="primary" size="sm" onClick={() => onClickItem(expandProfileConfig[branches][0])} className={classes.button}>{t('edit_profile')}</Button>
            {/* </StyledMenuItem> */}
            {expandProfileConfig[branches].map((item, index) => {
                if(item.showMenu || 
                    (item.id == 'order_history' && isOrder) ||
                    (item.id == 'topup_wallet' && showTopup) ||
                    (item.id == 'transactions' && isRewards) ||
                    (item.id == 'wallet_journals' && isRewards) ||
                    (item.id == 'service_requests' && showServiceRequests) ||
                    (item.id == 'mobile_pass_card' && showMobilePass) || 
                    (item.id == 'redeem_pass' && isRedeemPass)
                    ){
                    return(
                        <StyledMenuItem key={index} onClick={() => onClickItem(item)}>
                        <ListItemIcon >
                            <item.icon />
                        </ListItemIcon>
                        <ListItemText primary={t(item.title)} />
                    </StyledMenuItem>
                    )
                }
            }

            )}
            <Divider />
            <StyledMenuItem onClick={onLogout}>
                <ListItemIcon>
                    <LogoutIcon />
                </ListItemIcon>
                <ListItemText primary={t('logout')} />
            </StyledMenuItem>
        </StyledMenu>
    )
}
export default withRouter(withStyles(headerStyles)(withTranslation()(Header)));
// export default Header;